export default __webpack_public_path__ + "static/media/480_business01-en-mobile.31c5b8b1.png";